import { Button, Col, Row } from "reactstrap";
import { useState, useRef, useEffect } from "react";
import "react-circular-progressbar/dist/styles.css";
import CompletePopup from "./completepopup";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import RotatePhonePopup from "../RotatePhonePopup";
import NoDataFound2 from "../NoData2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { useSnackbar } from "../context/SnackbarContext";
import { useLanguage } from "../context/Languagecontext";
import { useTranslatedText } from "../../hooks/useTranslatedText";


// img
import demo from "../../img/demo.png"
import editicon from "../../img/editicon.png"
import play from "../../img/play.png"
import pause from "../../img/pause.png"
import { convertToNativeNumerals } from "../../utils/numberUtils";
import DiceButton from "./DiceButton";
import useBadWordDetection from "../../hooks/Usebadworddetection";
import BadWordWarning from "./Badwordwarning";

const LoadingSpinner = () => (
    <div className="w-100 h-100 d-flex justify-content-center align-items-center">
        <style>{`
            @keyframes shimmer {
                0% {
                    background-position: 200% 0;
                }
                100% {
                    background-position: -200% 0;
                }
            }
        `}</style>
        <div
            style={{
                width: '95%',
                height: '90%',
                borderRadius: '16px',
                background: 'linear-gradient(90deg, #e8e8e8 0%, #e8e8e8 45%, #f5f5f5 50%, #ffffff 55%, #f5f5f5 60%, #e8e8e8 65%, #e8e8e8 100%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite ease-in-out'
            }}
        />
    </div>
);

const Category2 = ({ hint, uploadedImage, originalData, username, category, timestamp }) => {
    const { lanText, t } = useLanguage();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const getCommentStorageKey = (username, category, timestamp) => {
        return `comment_${username}_${category}_${timestamp}`;
    };
    const [comment, setComment] = useState(() => {
        const storageKey = getCommentStorageKey(username, category, timestamp);
        const savedComment = sessionStorage.getItem(storageKey);
        return savedComment || '';
    });
    const { hasBadWord } = useBadWordDetection(comment);
    const [isUploading, setIsUploading] = useState(false);
    const [mediaLoaded, setMediaLoaded] = useState(false);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const [isVideoHovering, setIsVideoHovering] = useState(false);
    const [isShaking, setIsShaking] = useState(false);
    const [pauseButtonTimer, setPauseButtonTimer] = useState(null);
    const [thumbnailLoaded, setThumbnailLoaded] = useState(false);
    const [textareaClicked, setTextareaClicked] = useState(false);
    const [videoPauseTime, setVideoPauseTime] = useState(0);
    const [isCheckingConnection, setIsCheckingConnection] = useState(false);
    const [isCheckingConnection2, setIsCheckingConnection2] = useState(false);
    const [isVideoLoading, setIsVideoLoading] = useState(false);


    // ✅ NEW: Global loading state - when ANY button is clicked, all buttons disable
    const [isAnyActionInProgress, setIsAnyActionInProgress] = useState(false);

    const topRef = useRef(null);
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSmallScreen = window.innerWidth < 380 && window.innerWidth !== 360;
    const [mediaError, setMediaError] = useState(false);
    const [retryCount, setRetryCount] = useState(0);
    const [showFullscreen, setShowFullscreen] = useState(false);
    const [exitType, setExitType] = useState('');
    const [exitType2, setExitType2] = useState('');
    const [videoSrc, setVideoSrc] = useState(null);
    const [videoCached, setVideoCached] = useState(false);

    const exitAnimation = exitType === 'button'
        ? { scale: 0, opacity: 1 }    // slide down when close button
        : { undefined };

    const exitAnimation2 = exitType2 === 'true'
        ? { scale: 0, opacity: 1 }    // slide down when close button
        : { scale: 1, opacity: 1 };

    const MAX_RETRIES = 2;
    const { showSnackbar } = useSnackbar();

    const fullscreenVideoRef = useRef(null);
    const [isFullscreenPlaying, setIsFullscreenPlaying] = useState(false);
    const [showFullscreenControls, setShowFullscreenControls] = useState(true);
    const [fullscreenControlsTimer, setFullscreenControlsTimer] = useState(null);


    const isInAppBrowser = () => {
        const ua = navigator.userAgent || navigator.vendor;
        return /Instagram|FBAN|FBAV|Messenger|Telegram|Snapchat/i.test(ua);
    };
    const textareaWidth = () => {
        if (textareaClicked) return '52px';
        if (window.innerWidth < 376) return '94%';
        return '94%';
    };

    const textareaHeight = () => {
        if (window.innerWidth < 380 && window.innerWidth !== 360) return '52px';
        return '85px';
    };


    const textareaRef = useRef(null);
    const mainContainerRef = useRef(null);
    const videoRef = useRef(null);

    const data = originalData?.question || [];
    const currentItem = Array.isArray(data)
        ? data.find(item => item.category === category && String(item.answer?.timestamp) === String(timestamp))
        : null;

    const userImage = currentItem?.answer?.image || demo;
    const videoImage = currentItem?.answer?.thumbnailUrl || demo;
    const userType = currentItem?.answer?.quetype || "image";
    const questionText = currentItem?.question || t.picRoast?.defaultQuestion;
    const translatedQuestion = useTranslatedText(questionText, lanText);

    const isCommentValid = comment.trim().length > 0;
    const maxLength = 250;
    // ================================================
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        const isDisabled = isUploading || isCheckingConnection || isCheckingConnection2 || isPlaying;
        window.dispatchEvent(new CustomEvent('dropdownDisabledState', {
            detail: { disabled: isDisabled }
        }));
    }, [isUploading, isCheckingConnection, isCheckingConnection2, isPlaying]);

    useEffect(() => {
        setIsAnyActionInProgress(isUploading || isCheckingConnection || isCheckingConnection2);
    }, [isUploading, isCheckingConnection, isCheckingConnection2]);

    const handlePlayPause = () => {
    if (!videoRef.current || isAnyActionInProgress) return;

    if (isPlaying) {
        videoRef.current.pause();
        setIsPlaying(false);
        setVideoPauseTime(videoRef.current.currentTime);
        if (pauseButtonTimer) {
            clearTimeout(pauseButtonTimer);
            setPauseButtonTimer(null);
        }
    } else {
        if (!navigator.onLine) {
            showSnackbar(t?.common?.nointertoast || "No internet!", "error");
            return;
        }

        // ✅ Guard: no valid source loaded yet
        if (!videoRef.current.src || videoRef.current.src === window.location.href) {
            showSnackbar("Video not ready yet, please wait.", "error");
            return;
        }

        if (videoPauseTime > 0) {
            videoRef.current.currentTime = videoPauseTime;
        }

        // ✅ If not ready, wait for canplay
        if (videoRef.current.readyState < 2) {
            setIsVideoLoading(true);
            videoRef.current.addEventListener('canplay', () => {
                setIsVideoLoading(false);
                videoRef.current.play()
                    .then(() => {
                        setIsPlaying(true);
                        setIsVideoHovering(false);
                    })
                    .catch((err) => console.log('Play after canplay error:', err));
            }, { once: true });
            return;
        }

        videoRef.current.play()
            .then(() => {
                setIsPlaying(true);
                setIsVideoHovering(false);
            })
            .catch((error) => {
                console.log('Play error:', error);
                showSnackbar("Couldn't play video. Try again.", "error");
            });
    }
};

    const handlePause = () => {
        if (!videoRef.current) return;

        if (isPlaying) {
            setVideoPauseTime(videoRef.current.currentTime); // Save current time
            videoRef.current.pause();
            setIsPlaying(false);
            if (pauseButtonTimer) {
                clearTimeout(pauseButtonTimer);
                setPauseButtonTimer(null);
            }
        }
    };

    // Calculate character counts - Added for character limit display
    const typedChars = [...comment].length;
    const remainingChars = maxLength - [...comment].length;

    // Trigger shake animation - Added shake functionality
    const triggerShake = () => {
        setIsShaking(true);
        setTimeout(() => setIsShaking(false), 600);
    };

    // Handle text change with limit check - Updated to include character limit
    const handleTextChange = (e) => {
        const newValue = e.target.value;

        if ([...newValue].length > maxLength) {
            triggerShake();
            return;
        }

        setComment(newValue);
    };

    useEffect(() => {
        if (userType === "video" && userImage) {
            const cacheKey = `video_cache_${userImage}`;
            const cachedBlobUrl = sessionStorage.getItem(cacheKey);

            if (cachedBlobUrl && cachedBlobUrl.startsWith('blob:')) {
                setVideoSrc(cachedBlobUrl);
                setVideoCached(true);
                return; // ✅ Don't set up cleanup if using existing cache
            }

            let blobUrlToRevoke = null; // ✅ Track only the URL we created

            const cacheVideo = async () => {
                try {
                    const response = await fetch(userImage);
                    const blob = await response.blob();
                    const blobUrl = URL.createObjectURL(blob);
                    blobUrlToRevoke = blobUrl; // ✅ Track it

                    sessionStorage.setItem(cacheKey, blobUrl);
                    setVideoSrc(blobUrl);
                    setVideoCached(true);
                } catch (error) {
                    setVideoSrc(userImage);
                    setVideoCached(true);
                }
            };

            cacheVideo();

            // ✅ Only revoke on full unmount, not on every re-render
            return () => {
                if (blobUrlToRevoke) {
                    URL.revokeObjectURL(blobUrlToRevoke);
                    sessionStorage.removeItem(cacheKey); // Clean up stale key too
                }
            };
        }
    }, [userImage, userType]);

    // Handle media preloading
    useEffect(() => {
        setMediaLoaded(false);
        setThumbnailLoaded(false);
        setMediaError(false);
        setRetryCount(0);

        let retryTimeout;

        if (userType === "image") {
            const img = new Image();
            img.onload = () => {
                setMediaLoaded(true);
                setMediaError(false);
            };
            img.onerror = () => {
                if (retryCount < MAX_RETRIES) {
                    retryTimeout = setTimeout(() => {
                        setRetryCount(prev => prev + 1);
                        const retryImg = new Image();
                        retryImg.onload = () => {
                            setMediaLoaded(true);
                            setMediaError(false);
                        };
                        retryImg.onerror = () => {
                            if (retryCount + 1 >= MAX_RETRIES) {
                                setMediaError(true);
                            }
                        };
                        retryImg.src = userImage;
                    }, 2000);
                } else {
                    setMediaError(true);
                }
            };
            img.src = userImage;
        }

        if (userType === "video" && videoImage) {
            const img = new window.Image();
            img.onload = () => {
                setThumbnailLoaded(true);
                setMediaError(false);
            };
            img.onerror = () => {
                if (retryCount < MAX_RETRIES) {
                    retryTimeout = setTimeout(() => {
                        setRetryCount(prev => prev + 1);
                        const retryImg = new Image();
                        retryImg.onload = () => {
                            setThumbnailLoaded(true);
                            setMediaError(false);
                        };
                        retryImg.onerror = () => {
                            if (retryCount + 1 >= MAX_RETRIES) {
                                setMediaError(true);
                            }
                        };
                        retryImg.src = videoImage;
                    }, 2000);
                } else {
                    setMediaError(true);
                }
            };
            img.src = videoImage;
        } else {
            setThumbnailLoaded(true);
        }

        return () => {
            if (retryTimeout) clearTimeout(retryTimeout);
        };
    }, [userImage, userType, videoImage, retryCount]);

    useEffect(() => {
        const videoElement = videoRef.current;

        if (!videoElement) return;

        const handleVideoEnd = () => {
            setIsPlaying(false);
            setIsVideoHovering(true);
            setVideoPauseTime(0); // Reset to start
            videoElement.currentTime = 0; // Reset video to beginning
        };

        videoElement.addEventListener('ended', handleVideoEnd);

        return () => {
            videoElement.removeEventListener('ended', handleVideoEnd);
        };
    }, []);

    // Auto-pause video when switching to typing mode
    useEffect(() => {
        if (!textareaClicked && videoRef.current) {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    }, [textareaClicked]);

    useEffect(() => {
        const storageKey = getCommentStorageKey(username, category, timestamp);
        if (comment) {
            sessionStorage.setItem(storageKey, comment);
        } else {
            sessionStorage.removeItem(storageKey);
        }
    }, [comment, username, category, timestamp]);

    useEffect(() => {
        const handlePopState = () => {
            if (showSuccessModal) {
                setShowSuccessModal(false);
                // sessionStorage.setItem("timer", "false");
                const url = new URL(window.location.href);
                if (url.searchParams.has("success")) {
                    url.searchParams.delete("success");
                    window.history.replaceState({}, "", url.pathname);
                }
            }
        };

        // Add state to history when modal opens
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [showSuccessModal]);

    useEffect(() => {
        const handlePopState = () => {
            if (showFullscreen) {
                setExitType('');
                setShowFullscreen(false);
                // sessionStorage.setItem("timer", "false");
                const url = new URL(window.location.href);
                if (url.searchParams.has("fullscreen")) {
                    url.searchParams.delete("fullscreen");
                    window.history.replaceState({}, "", url.pathname);
                }
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [showFullscreen]);


    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("fullscreen") === "1") {
            setShowFullscreen(true);
        }

        if (urlParams.get("success") === "1") {
            setShowSuccessModal(true);
        }

    }, [showFullscreen, showSuccessModal]);


    const scrollToTop = () => {
        setTimeout(() => {
            window.scrollTo(0, 0);
            if (mainContainerRef.current) mainContainerRef.current.scrollTop = 0;
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }, 0);
    };

    // 3. Update your handleBlur function:
    const handleEditClick = () => {
        if (isAnyActionInProgress) return; // ✅ UPDATED

        handlePause();
        setTextareaClicked(true);

        setTimeout(() => {
            if (textareaRef.current) {
                const length = textareaRef.current.value.length;
                textareaRef.current.focus(); // prevent default scrolling
                textareaRef.current.setSelectionRange(length, length);
            }
        }, 400);
    };



    // Update handleBlur
    const handleBlur = () => {
        if (videoRef.current && isPlaying) {
            setVideoPauseTime(videoRef.current.currentTime); // Save time before pausing
        }
        scrollToTop();
        setTextareaClicked(false);
    };

    // Add this ref at the top with other refs
    const scrollTimeoutRef = useRef(null);

    const handleFocus = (e) => {
        // Prevent default scroll behavior
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        // Clear any pending scroll operations
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        // Scroll to top immediately to prevent keyboard push
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        // Then scroll to topRef smoothly after a brief delay
        scrollTimeoutRef.current = setTimeout(() => {
            requestAnimationFrame(() => {
                if (topRef.current) {
                    const element = topRef.current;
                    const rect = element.getBoundingClientRect();
                    const scrollTop = window.scrollY || document.documentElement.scrollTop;
                    const targetY = rect.top + scrollTop;

                    window.scrollTo({
                        top: targetY,
                        behavior: "smooth"
                    });
                }
            });
        }, 100);
    };

    // Don't forget to cleanup in useEffect
    useEffect(() => {
        return () => {
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, []);

    const handleKeyDown = (e) => {
        // On mobile keyboards, when user presses the "Done" button
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevent default behavior (new line)

            // Blur the textarea to hide the keyboard
            e.target.blur();
        }
    };

    // 5. Update your handleTextareaClick function:
    const handleTextareaClick = () => {
        if (isAnyActionInProgress) return; // ✅ UPDATED

        handlePause()
        setTextareaClicked(true);
        setTimeout(() => {
            textareaRef.current?.focus();
        }, 400);
    };

    useEffect(() => {
        return () => {
            if (pauseButtonTimer) {
                clearTimeout(pauseButtonTimer);
            }
        };
    }, [pauseButtonTimer]);

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.focus();
            const length = textareaRef.current.value.length;
            textareaRef.current.setSelectionRange(length, length);
        }
    }, []);

    const base64ToFile = (base64String, fileName) => {
        const arr = base64String.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], fileName, { type: mime });
    };


    const upload = async () => {
        const deviceIp = localStorage.getItem("deviceIp");
        setIsUploading(true);

        try {
            const formData = new FormData();
            formData.append('image', userImage);
            formData.append('quetype', userType);
            formData.append('hint', hint);
            if (uploadedImage) {
                if (uploadedImage.startsWith('data:image')) {
                    formData.append('uploadedImage', base64ToFile(uploadedImage, 'hintImage.jpg'));
                } else {
                    formData.append('uploadedImage', uploadedImage);
                }
            }
            formData.append('category', category);
            formData.append("webCategory", category);
            formData.append('comment', comment);
            formData.append('userLocation', "allow");
            formData.append('id', originalData.id);
            formData.append('deviceIp', deviceIp);
            formData.append('username', username);
            formData.append('timestamp', timestamp);

            await axios.post('https://api.lolcards.link/api/newinbox/create', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            const url = new URL(window.location.href);
            url.searchParams.set('success', '1'); // add ?fullscreen=1
            window.history.pushState({ success: true }, '', url.toString());
            setShowSuccessModal(true);
            const storageKey = getCommentStorageKey(username, category, timestamp);
            sessionStorage.removeItem(storageKey);
            setComment('');
            // setTimeout(() => {
            //     const isAndroid = /Android/i.test(navigator.userAgent);
            //     const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

            //     let playStoreURL = 'https://api.lolcards.link/api/download?source=a7b8b02061';
            //     let appStoreURL = 'https://api.lolcards.link/api/download?source=a7b8b02061';

            //     const timer = sessionStorage.getItem("timer");
            //     if (timer === "true" && navigator.onLine) {
            //         if (isAndroid) {
            //             window.location.href = playStoreURL;
            //         } else if (isiOS) {
            //             window.location.href = appStoreURL;
            //         } else {
            //             window.location.href = playStoreURL;
            //         }
            //     }
            // }, 3000);
        } catch (error) {
            // console.error('Error uploading data:', error);
            showSnackbar(t?.common?.apiFail || 'Request failed. Please try again after some time!', "error");

        } finally {
            setIsUploading(false);
        }
    };

    const checkInternetConnection = async () => {
        // Add 2 second delay
        await new Promise(resolve => setTimeout(resolve, 500));

        // First check navigator.onLine
        if (!navigator.onLine) {
            return false;
        }

        // Double-check with a real network request
        try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

            clearTimeout(timeoutId);
            return true;
        } catch (error) {
            // console.log('Network check failed:', error);
            return false;
        }
    };


    const handleNextClick = async () => {
        if (isAnyActionInProgress) return; // ✅ UPDATED

        handlePause()
        setIsCheckingConnection(true);

        // Check internet connection first (includes 2 second delay)
        const isOnline = await checkInternetConnection();

        setIsCheckingConnection(false);

        if (!isOnline) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }
        if (isCommentValid && !isUploading) {
            try {
                await upload();
                await axios.patch(
                    'https://api.lolcards.link/api/admin/monitoring',
                    { categoryname: category, id: originalData.id }
                );
            } catch (error) {
                // console.error('Error updating monitoring:', error);
            }
        }
    };


    const handleFull = async () => {
        if (isAnyActionInProgress) return; // ✅ UPDATED

        setIsCheckingConnection2(true);

        // Check internet connection first (includes 2 second delay)
        const isOnline = await checkInternetConnection();

        setIsCheckingConnection2(false);

        if (!isOnline) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }

        const url = new URL(window.location.href);
        url.searchParams.set('fullscreen', '1'); // add ?fullscreen=1
        window.history.pushState({ fullscreen: true }, '', url.toString());
        setExitType2('true');
        setShowFullscreen(true);
        handlePause();
    };

    // Render media content with loading spinner
    const renderMediaContent = () => {
        // For image: show spinner until loaded
        if (userType === "image" && !mediaLoaded) {
            return <LoadingSpinner />;
        }
        if (userType === "video" && !thumbnailLoaded) {
            return <LoadingSpinner />;
        }

        // Blurred background
        const blurredBackground = (
            <motion.div
                className="position-absolute top-0 start-0 w-100 h-100"
                initial={{ filter: "blur(40px)", opacity: 0.4, scale: 1.25 }}
                animate={{ filter: "blur(20px)", opacity: 1, scale: 1.1 }}
                transition={{ duration: 0.1, ease: "easeInOut" }}
                style={{
                    backgroundImage: `url(${userType === "video" ? videoImage : userImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    brightness: "95%",
                    zIndex: 0,
                }}
            />
        );

        const blurredBackgroundvideo = (
            <>
                <motion.div
                    initial={{ filter: "blur(30px)" }}
                    animate={{ filter: "blur(18px)" }}
                    transition={{ duration: 0.1 }}
                    style={{
                        backgroundImage: `url(${userType === "video" ? videoImage : userImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        transform: "scale(1.2)",
                        zIndex: 0,
                    }}
                />

                {/* 2. Animated Image Overlay */}
                <img
                    src={userType === "video" ? videoImage : userImage}
                    alt="thumbnail"
                    className="position-absolute top-50 start-50 translate-middle"
                    style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        width: '100%',
                        height: '100%',
                        objectFit: "contain",
                        objectPosition: "center center",
                        WebkitTransform: 'translateZ(0)',
                        transform: 'translateZ(0)',
                        zIndex: 1,
                        transition: "opacity 0.4s cubic-bezier(0.34, 1.56, 0.44, 1)",
                        animation: "fadeInUp 0.8s ease-out",
                    }}
                />

                {/* 3. Spinner */}
                <div
                    className="position-absolute top-50 start-50 translate-middle"
                    style={{ zIndex: 2 }}
                >
                    <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </>
        );

        if (userType === "video") {
            return (
                <>
                    {blurredBackgroundvideo}
                    <div
                        className="position-relative h-100 w-100 d-flex justify-content-center align-items-center"
                        onMouseEnter={() => !isAnyActionInProgress && setIsVideoHovering(true)} // ✅ UPDATED
                        onMouseLeave={() => !isAnyActionInProgress && setIsVideoHovering(false)} // ✅ UPDATED
                        onClick={() => {
                            if (isAnyActionInProgress) return; // ✅ UPDATED

                            handlePlayPause();
                            if (isVideoPlaying) {
                                setIsVideoHovering(true);
                                if (pauseButtonTimer) clearTimeout(pauseButtonTimer);
                                const timer = setTimeout(() => setIsVideoHovering(false), 2000);
                                setPauseButtonTimer(timer);
                            }
                        }}
                        style={{ cursor: isAnyActionInProgress ? 'not-allowed' : 'pointer' }} // ✅ UPDATED
                    >
                        <video
                            ref={videoRef}
                            src={videoSrc || userImage} // Use cached videoSrc
                            poster={videoImage}
                            controls={false}
                            loop={false}
                            playsInline
                            preload="auto"
                            onPlay={() => setIsVideoPlaying(true)}
                            onPause={() => setIsVideoPlaying(false)}
                            onEnded={() => {
                                setIsVideoPlaying(false);
                                setIsPlaying(false);
                                setIsVideoHovering(true);
                                setVideoPauseTime(0);
                            }}
                            onError={(e) => {
                                // console.log('Video error:', e);
                            }}
                            className="position-relative"
                            style={{
                                maxWidth: "100%", maxHeight: "100%",
                                objectFit: "contain", zIndex: 3,
                                width: '100%',
                                height: '100%',
                                objectPosition: "center center",
                                WebkitTransform: 'translateZ(0)',
                                transform: 'translateZ(0)',
                                cursor: isAnyActionInProgress ? 'not-allowed' : 'pointer', // ✅ UPDATED
                                pointerEvents: isAnyActionInProgress ? 'none' : 'auto' // ✅ UPDATED
                            }}
                            onClick={(e) => {
                                if (isAnyActionInProgress) { // ✅ UPDATED
                                    e.preventDefault();
                                    return;
                                }
                                handlePlayPause();
                            }}
                        />


                        <button
                            onClick={(e) => {
                                if (isAnyActionInProgress) { // ✅ UPDATED
                                    e.preventDefault();
                                    return;
                                }
                                handlePlayPause();
                            }}
                            disabled={isAnyActionInProgress} // ✅ UPDATED
                            className="btn p-0 d-flex align-items-center justify-content-center position-absolute"
                            style={{
                                top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 4,
                                backgroundColor: '#D8D8D8B2', backdropFilter: 'blur(3px)',
                                WebkitBackdropFilter: 'blur(3px)', border: 'none', borderRadius: '50%',
                                width: '50px', height: '50px', color: 'white',
                                boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
                                opacity: (!isPlaying || isVideoHovering) ? 1 : 0,
                                transition: 'opacity 0.3s ease',
                                cursor: isAnyActionInProgress ? 'not-allowed' : 'pointer', // :white_check_mark: UPDATED
                                pointerEvents: isAnyActionInProgress ? 'none' : 'auto' // :white_check_mark: UPDATED
                            }}
                        >
                            <img src={isPlaying ? pause : play} alt={isPlaying ? "pause" : "play"}
                                className="img-fluid" width={isPlaying ? 18 : 30} />
                        </button>
                    </div>
                </>
            );
        }

        // For image
        return (
            <>
                {blurredBackground}
                <img
                    src={userImage}
                    alt="userImage"
                    className="position-relative"
                    style={{
                        maxWidth: "100%", maxHeight: "100%",
                        objectFit: "contain", zIndex: 1,
                        width: '100%',
                        height: '100%',
                        objectPosition: "center center",
                        WebkitTransform: 'translateZ(0)',
                        transform: 'translateZ(0)',
                        // transform: mediaLoaded ? "scale(1)" : "scale(0.8)",
                        opacity: mediaLoaded ? 1 : 0,
                        transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.44, 1)"
                    }}
                    onLoad={() => setMediaLoaded(true)}
                />
            </>
        );
    };

    const renderThumbnail = () => {
        const imageStyle = {
            width: '100%',
            height: '100%',
            objectFit: 'cover',  // ensures image covers the container
            display: 'block',    // removes inline gaps for images
        };

        return (
            <div style={{ width: '100%', height: '100%' }}>
                {userType === "video" ? (
                    <img src={videoImage} alt="video thumbnail" style={imageStyle} />
                ) : (
                    <img src={userImage} alt="relation" style={imageStyle} />
                )}
            </div>
        );
    };


    useEffect(() => {
        if (showFullscreen) {
            document.body.style.overflow = 'hidden';

            // Auto-start video when fullscreen opens
            if (userType === "video" && fullscreenVideoRef.current) {
                setTimeout(() => {
                    fullscreenVideoRef.current.play()
                        .then(() => {
                            setIsFullscreenPlaying(true);
                            hideControlsAfterDelay();
                        })
                        .catch((error) => {
                            // console.log('Auto-play failed:', error);
                            // Keep controls visible if autoplay fails
                            setShowFullscreenControls(true);
                        });
                }, 600); // Small delay to ensure video element is ready
            }

            return () => {
                document.body.style.overflow = 'unset';
            };
        }
    }, [showFullscreen, userType]);

    useEffect(() => {
        return () => {
            if (fullscreenControlsTimer) {
                clearTimeout(fullscreenControlsTimer);
            }
        };
    }, [fullscreenControlsTimer]);

    const handleFullscreenPlayPause = () => {
        if (!fullscreenVideoRef.current) return;

        if (isFullscreenPlaying) {
            fullscreenVideoRef.current.pause();
            setIsFullscreenPlaying(false);
            setShowFullscreenControls(true);
            if (fullscreenControlsTimer) {
                clearTimeout(fullscreenControlsTimer);
                setFullscreenControlsTimer(null);
            }
        } else {
            if (!navigator.onLine) {
                showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
                return;
            }
            const playPromise = fullscreenVideoRef.current.play();

            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        setIsFullscreenPlaying(true);
                        hideControlsAfterDelay();
                    })
                    .catch((error) => {
                        // console.log('Fullscreen play error:', error);

                        if (!navigator.onLine && !videoCached) {
                            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
                        }
                    });
            }
        }
    };

    // const handleCloseFullscreen = () => {
    //     if (showSuccessModal) {
    //         // If success modal is showing, close it first
    //         setShowSuccessModal(false);
    //     } else {
    //         // Start exit animation

    //         // Save comment to parent state
    //         setComment(localComment);
    //         setExitType('button');

    //         setShowFullscreen(false);
    //         if (fullscreenVideoRef.current) {
    //             fullscreenVideoRef.current.pause();
    //         }
    //     }
    // };

    const hideControlsAfterDelay = () => {
        if (fullscreenControlsTimer) {
            clearTimeout(fullscreenControlsTimer);
        }
        const timer = setTimeout(() => {
            setShowFullscreenControls(false);
        }, 2000); // Changed from 500ms to 2000ms for better UX
        setFullscreenControlsTimer(timer);
    };

    const handleFullscreenVideoClick = () => {
        // Show controls temporarily when clicking, regardless of play state
        setShowFullscreenControls(true);
        if (isFullscreenPlaying) {
            // If playing, hide controls after a delay
            hideControlsAfterDelay();
        }
        // If paused, keep controls visible
    };

    if (mediaError) {
        return (
            <NoDataFound2
                style={{ height: '100vh' }}
                t={t.noData2}
                username={username}
                category={category}
                timestamp={timestamp}
            />
        );
    }

    return (
        <div className='blue-bg GTRegular' ref={mainContainerRef} 
            style={{height : "100dvh"}}>
            <div className='h-100 hint-bg2 pt-42'>
                <Row className={`m-0 h-100`} >
                    <Col className="p-0 d-flex flex-column" style={{ height: '100%' }}>

                        {/* Top Section */}
                        <div
                            className="d-flex justify-content-center align-items-center mt-1"
                            style={{
                                height: isiOS ? "75px" : "100px",
                                padding: "20px 0"
                            }}
                        >
                            <div className="text-center" style={{ maxWidth: "clamp(290px, 100%, 420px)", width: "clamp(290px, 100%, 420px)" }}>
                                <p
                                    className={`lh-sm mx-auto px-3 m-0`} style={{ color: "#FFFFFF", fontSize: "18px" }}
                                >
                                    {userType === "video" ? t.picRoast.entercomment2 : t.picRoast.entercomment}
                                </p>

                            </div>
                        </div>

                        {/* middle div */}
                        <div ref={topRef} className="d-flex justify-content-center align-items-center px-4 pt-2" style={{ minHeight: textareaClicked ? '60.33%' : "auto" }}>
                            <div
                                className={`h-100 rounded-19`}
                                style={{
                                    maxWidth: textareaClicked ? "clamp(290px, 100%, 420px)" : "clamp(290px, 100%, 420px)",
                                    width: textareaClicked ? "clamp(290px, 100%, 420px)" : "clamp(290px, 100%, 420px)",
                                    height: textareaClicked ? '260px' : '100%',
                                }}
                            >
                                <div
                                    className={`rounded-19 position-relative category2  ${textareaClicked ? `w-100 ${isShaking ? 'shake-animation' : ''}` : 'pb-3'}`}
                                    style={{
                                        height: textareaClicked ? '260px' : '100%',
                                        backgroundColor: textareaClicked ? '#DCE6F8' : '#fff',
                                        boxShadow: '0px 2px 4px rgba(0,0,0,0.3)',
                                        transition: `
                                            border 0s cubic-bezier(0.4, 0, 0.2, 1),
                                            boxShadow 0.4s cubic-bezier(0.4, 0, 0.2, 1),
                                            height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                                            background-color 0s cubic-bezier(0.4, 0, 0.2, 1),
                                            box-shadow 0.4s cubic-bezier(0.4, 0, 0.2, 1)
                                        `
                                    }}
                                >
                                    <div
                                        className={`d-flex align-items-center justify-content-center GTBold py-3 ${textareaClicked ? 'text-start rounded-19-top' : 'text-center px-3'}`}
                                        style={{
                                            minHeight: textareaClicked ? '75px' : '75px',
                                            fontSize: 'clamp(14px, 4vw, 16px)',
                                            lineHeight: "22px",
                                            backgroundColor: textareaClicked ? '#fff' : 'transparent',
                                            color: "#000",
                                            paddingLeft: textareaClicked ? '80px' : '0px',
                                            paddingRight: textareaClicked ? '8%' : '0px',
                                            transition: 'all 0s cubic-bezier(0.4, 0, 0.2, 1)', // <-- smooth transition
                                        }}
                                    >
                                        {t?.common?.que || 'Que:'} {' '} {translatedQuestion}
                                    </div>

                                    <div className="mx-1 category2" style={{ minHeight: "200px", overflow: comment ? "auto" : "hidden" }}>

                                        <div
                                            className={`overflow-hidden d-flex justify-content-center align-items-center mx-auto  ${textareaClicked ? 'rounded-circle' : 'rounded-4'
                                                }`}
                                            style={{
                                                position: textareaClicked ? 'absolute' : 'relative',
                                                top: textareaClicked ? '5%' : 'auto',
                                                left: textareaClicked ? '3%' : 'auto',
                                                width: textareaWidth(),
                                                aspectRatio: isSmallScreen && !textareaClicked ? '3 / 2.3' : '1 / 1',
                                                willChange: 'transform, width, height',
                                                transition: `
                                                width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                                                height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                                                top 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                                                left 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                                                position 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                                                border-radius 0.6s cubic-bezier(0.4, 0, 0.2, 1),
                                                background-color 0.6s cubic-bezier(0.4, 0, 0.2, 1)
                                                `,
                                            }}
                                        >

                                            {textareaClicked ? renderThumbnail() : renderMediaContent()}

                                            <button
                                                onClick={handleFull}
                                                disabled={isAnyActionInProgress} // ✅ UPDATED
                                                className="border-0 rounded-circle position-absolute d-flex align-items-center justify-content-center p-0"
                                                style={{
                                                    width: "43px",
                                                    height: "43px",
                                                    bottom: "10px",
                                                    right: "10px",
                                                    cursor: isAnyActionInProgress ? "not-allowed" : "pointer", // ✅ UPDATED
                                                    backgroundColor: 'rgba(44, 44, 44, 0.7)',
                                                    zIndex: 9999,
                                                    opacity: textareaClicked || !thumbnailLoaded ? "0" : "1"
                                                }}
                                            >
                                                {isCheckingConnection2 ? (
                                                    <div className="custom-spinner" style={{ borderTopColor: "#fff" }} />
                                                ) : (
                                                    <FontAwesomeIcon icon={faExpand} className="text-white" style={{ fontSize: "20px" }} />
                                                )}
                                            </button>
                                        </div>

                                        {textareaClicked ? (
                                            // ✅ SHOW THIS WHEN textareaClicked = true
                                            <div className='px-1 pt-1 fw-semibold text-start d-flex flex-column' style={{ paddingBottom: "65px", height: "200px" }}>
                                                <textarea
                                                    ref={textareaRef}
                                                    placeholder={t.picRoast.typeComment}
                                                    value={comment}
                                                    onKeyDown={handleKeyDown}
                                                    onChange={handleTextChange}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    className='form-control border-0 flex-grow-1 custom-textarea'
                                                    style={{
                                                        resize: 'none', backgroundColor: 'transparent',
                                                        outline: 'none', boxShadow: 'none', color: 'black',
                                                        fontSize: '16px', fontWeight: '400', lineHeight: '1.5'
                                                    }}
                                                    enterKeyHint="done"
                                                    inputMode="text"
                                                    autoFocus
                                                />

                                                <DiceButton
                                                    category={category}
                                                    onContentFetched={(text) => setComment(text)}
                                                    disabled={isUploading || isCheckingConnection}
                                                />
                                            </div>
                                        ) : (
                                            // ✅ SHOW THIS WHEN textareaClicked = false
                                            <>
                                                <div className="d-flex align-items-center justify-content-center position-relative px-2" style={{}}>
                                                    {comment ? (
                                                        <Row className="w-100 position-relative align-items-center h-100 pt-1" style={{ marginTop: isSmallScreen ? "0px" : "0px" }}>
                                                            <Col
                                                                xs={10}
                                                                onClick={handleEditClick}
                                                                className="p-2 cursor GTMedium fade-in"
                                                                style={{
                                                                    fontSize: '16px',
                                                                    maxHeight: textareaHeight(),
                                                                    minHeight: "35px",
                                                                    height: 'auto',
                                                                    wordBreak: 'break-all',
                                                                    overflowWrap: 'anywhere',
                                                                    whiteSpace: 'pre-wrap',
                                                                    cursor: isAnyActionInProgress || showFullscreen ? 'not-allowed' : 'pointer', // ✅ ADDED
                                                                    pointerEvents: isAnyActionInProgress || showFullscreen ? 'none' : 'auto' // ✅ ADDED
                                                                }}
                                                            >
                                                                {comment}
                                                            </Col>

                                                            <Col xs={2} className="d-flex justify-content-end p-0 h-100">
                                                                <button
                                                                    onClick={handleEditClick}
                                                                    disabled={isAnyActionInProgress || showFullscreen} // ✅ ADDED
                                                                    className="btn btn-link p-0"
                                                                    style={{
                                                                        fontSize: '18px',
                                                                        color: '#666',
                                                                        cursor: isAnyActionInProgress || showFullscreen ? 'not-allowed' : 'pointer',// ✅ ADDED
                                                                        opacity: "1"
                                                                    }}
                                                                >
                                                                    <div
                                                                        className='rounded-circle overflow-hidden blue-bg d-flex justify-content-center align-items-center'
                                                                        style={{ width: 32, height: 32 }}
                                                                    >
                                                                        <img src={editicon} alt='edit' style={{ width: 14, height: 14 }} />
                                                                    </div>
                                                                </button>
                                                            </Col>
                                                        </Row>
                                                    ) : (
                                                        <div className="w-100 position-relative h-100 d-flex align-items-center pt-3">
                                                            <textarea
                                                                className="form-control border-0 category2-textarea"
                                                                placeholder={t.picRoast.typeComment}
                                                                rows="1"
                                                                style={{
                                                                    resize: 'none',
                                                                    fontSize: '14px',
                                                                    background: 'transparent',
                                                                    minHeight: '45px',
                                                                    cursor: isAnyActionInProgress || showFullscreen ? 'not-allowed' : 'pointer', // ✅ UPDATED
                                                                    pointerEvents: isAnyActionInProgress || showFullscreen ? 'none' : 'auto' // ✅ ADDED
                                                                }}
                                                                onClick={handleTextareaClick}
                                                                readOnly
                                                            />
                                                            <button
                                                                onClick={handleTextareaClick}
                                                                disabled={isAnyActionInProgress || showFullscreen} // ✅ ADDED
                                                                className="btn btn-link p-0 position-absolute text-decoration-none pb-1"
                                                                style={{
                                                                    right: '0px', top: '32px', transform: 'translateY(-50%)',
                                                                    fontSize: '14px', color: '#D0D0D0',
                                                                    opacity: "1"
                                                                }}
                                                            >
                                                                {convertToNativeNumerals(0, lanText)}/{convertToNativeNumerals(250, lanText)}
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {textareaClicked && (
                                        <>
                                            <p className={`text-end text-white pe-4 GTMedium mb-0`}>
                                                {convertToNativeNumerals(typedChars, lanText)}/{convertToNativeNumerals(maxLength, lanText)}
                                            </p>

                                            <BadWordWarning
                                                visible={hasBadWord}
                                                message={
                                                    t?.common?.badWordWarning ||
                                                    "Avoid using offensive language"
                                                }
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>


                        {/* Bottom Section - Next Button */}
                        {!textareaClicked && (
                            <div
                                className="d-flex justify-content-center align-items-center px-3 mx-auto flex-grow-1"
                                style={{
                                    width: 320,
                                    transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.1s'
                                }}
                            >
                                <Button
                                    className={`rounded-pill border-0 ${isiOS ? 'my-3' : 'my-4'} mx-auto w-100 bg-black GTMedium ${isCommentValid && !isAnyActionInProgress ? 'button-enabled' : 'button-disabled'
                                        }`} // ✅ UPDATED
                                    style={{
                                        padding: "14px 1px",
                                        cursor: (isCommentValid && !isAnyActionInProgress && !showFullscreen) ? 'pointer' : 'not-allowed', // ✅ UPDATED
                                        transform: 'scale(1)',
                                        height: "50px",
                                        transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                                        boxShadow: isCommentValid
                                            ? '0 8px 25px rgba(0,0,0,0.15), 0 3px 10px rgba(0,0,0,0.1)'
                                            : '0 4px 15px rgba(0,0,0,0.1)',
                                        opacity: !isCommentValid || !thumbnailLoaded ? "0.5" : "1"
                                    }}
                                    onClick={handleNextClick}
                                    disabled={!isCommentValid || !thumbnailLoaded || isAnyActionInProgress || showFullscreen} // ✅ UPDATED
                                    onMouseEnter={(e) => {
                                        if (isCommentValid && !isAnyActionInProgress) { // ✅ UPDATED
                                            e.target.style.transform = 'scale(1.05) translateY(-2px)';
                                            e.target.style.boxShadow = '0 12px 35px rgba(0,0,0,0.2), 0 5px 15px rgba(0,0,0,0.15)';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'scale(1) translateY(0)';
                                        e.target.style.boxShadow = isCommentValid
                                            ? '0 8px 25px rgba(0,0,0,0.15), 0 3px 10px rgba(0,0,0,0.1)'
                                            : '0 4px 15px rgba(0,0,0,0.1)';
                                    }}
                                >
                                    {(isUploading || isCheckingConnection) ? (
                                        <div className="custom-spinner" style={{ borderTopColor: "#2F80ED" }} />
                                    ) : (
                                        <span
                                            style={{
                                                fontSize: "clamp(21px, 4.5vw, 27px)",
                                                lineHeight: 1,
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {t.common?.done || "Done"}
                                        </span>
                                    )}
                                </Button>
                            </div>
                        )}
                    </Col>
                </Row>

                <AnimatePresence>
                    {showFullscreen && (
                        <motion.div
                            initial={exitAnimation2}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={exitAnimation}
                            transition={{
                                duration: 0.4,
                                ease: [0.4, 0, 0.2, 1]
                            }}
                            className={`position-fixed top-0 start-0 w-100 h-100 d-flex flex-column`}
                            style={{
                                zIndex: 99999,
                                backgroundColor: '#000',
                            }}
                        >
                            {/* Media Content */}
                            <div className={`position-relative`} style={{ height: '100%' }}>
                                <div
                                    className={`w-100 h-100 d-flex justify-content-center align-items-center position-relative'}`}
                                    onClick={userType === "video" ? handleFullscreenVideoClick : undefined}
                                >
                                    {/* Blurred Background */}
                                    <motion.div
                                        className="position-absolute top-0 start-0 w-100 h-100"
                                        initial={{ filter: "blur(40px)", opacity: 0.6, scale: 1.35 }}
                                        animate={{ filter: "blur(20px)", opacity: 0.2, scale: 1.1 }}
                                        exit={{ filter: "blur(40px)", opacity: 0.6, scale: 1.1 }}
                                        transition={{ duration: 0, ease: "easeInOut" }}
                                        style={{
                                            backgroundImage: `url(${userType === "video" ? videoImage : userImage})`,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",
                                            brightness: "95%",
                                            zIndex: 0,
                                        }}
                                    />

                                    {userType === "video" ? (
                                        <>
                                            <video
                                                ref={fullscreenVideoRef}
                                                src={videoSrc || userImage}
                                                poster={videoImage}
                                                controls={false}
                                                playsInline
                                                preload="auto"
                                                className="position-relative"
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '100%',
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                    zIndex: 2,
                                                }}
                                                onClick={handleFullscreenPlayPause}

                                                /* 🔥 LOADING EVENTS */
                                                onLoadStart={() => setIsVideoLoading(true)}
                                                onWaiting={() => setIsVideoLoading(true)}   // buffering
                                                onCanPlay={() => setIsVideoLoading(false)}
                                                onPlaying={() => {
                                                    setIsVideoLoading(false);
                                                    setIsFullscreenPlaying(true);
                                                }}

                                                onPause={() => setIsFullscreenPlaying(false)}
                                                onEnded={() => {
                                                    setIsFullscreenPlaying(false);
                                                    setShowFullscreenControls(true);
                                                }}
                                                onError={(e) => {
                                                    setIsVideoLoading(false);
                                                    // console.log('Fullscreen video error:', e);
                                                }}
                                            />

                                            {isVideoLoading && (
                                                <div
                                                    className="position-absolute top-50 start-50 translate-middle
                                                    "
                                                    style={{ zIndex: 10 }}
                                                >
                                                    {/* Your loader */}
                                                    <div className="spinner-border text-light" />
                                                </div>
                                            )}

                                            {/* Custom Play/Pause Button */}
                                            <button
                                                onClick={handleFullscreenPlayPause}
                                                className="btn p-0 d-flex align-items-center justify-content-center position-absolute"
                                                style={{
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    zIndex: 10,
                                                    backgroundColor: '#D8D8D8B2',
                                                    backdropFilter: 'blur(3px)',
                                                    WebkitBackdropFilter: 'blur(3px)',
                                                    border: 'none',
                                                    borderRadius: '50%',
                                                    width: '50px',
                                                    height: '50px',
                                                    color: 'white',
                                                    boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.4)',
                                                    opacity: (!isFullscreenPlaying || showFullscreenControls) ? 1 : 0,
                                                    transition: 'opacity 0.3s ease',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <img
                                                    src={isFullscreenPlaying ? pause : play}
                                                    alt={isFullscreenPlaying ? "pause" : "play"}
                                                    className="img-fluid"
                                                    width={isFullscreenPlaying ? 18 : 30}
                                                />
                                            </button>
                                        </>
                                    ) : (
                                        <img
                                            src={userImage}
                                            alt="fullscreen"
                                            className="position-relative"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '100%',
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                zIndex: 1,
                                            }}
                                        />
                                    )}
                                </div>

                                {/* <button
                                    onClick={handleCloseFullscreen}
                                    className="btn btn-link position-absolute text-white rounded-circle d-flex align-items-center justify-content-center"
                                    style={{
                                        top: '25px',
                                        right: '25px',
                                        width: '40px',
                                        height: '40px',
                                        fontSize: '20px',
                                        backgroundColor: "rgba(44, 44, 44, 0.5)",
                                        zIndex: 10,
                                    }}
                                >
                                    <FontAwesomeIcon icon={faClose} />
                                </button> */}
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>

                <RotatePhonePopup
                    excludeWhen={[]}
                // excludeWhen={[textareaClicked, focus]}
                />
            </div>

            <CompletePopup
                showSuccessModal={showSuccessModal}
                toggle={() => setShowSuccessModal(false)}
                data={originalData}
                username={username}
                category={category}
                timestamp={timestamp}
                style={{ zIndex: 10000 }} // Add this to make it appear above fullscreen
            />

        </div>
    );
};

export default Category2;